module.exports = __webpack_public_path__ + "img/3-quad.b04a0f6c.png";